<template>
  <div>
    <h3
      style="
        text-align: center;
        color: #3272dc;
        margin-bottom: 30px;
        margin-top: 25px;
      "
      class="mobile-only"
    >
      Use your camera to take a picture of your {{ doc }}.
    </h3>
    <h3
      style="
        text-align: center;
        color: #3272dc;
        margin-bottom: 30px;
        margin-top: 25px;
      "
      class="desktop-only"
    >
      Upload a picture of your {{ doc }}.
    </h3>
    <p style="text-align: center">
      To quickly process your funds, we require you to securely upload a few
      documents.
    </p>
    <div class="file-container">
      <p style="margin-top: 10px; color: #415da7; margin-bottom: 0px">
        {{ doc }}
      </p>
      <div class="field">
        <div class="file is-large is-centered is-boxed is-link">
          <label class="file-label">
            <input class="file-input" type="file" name="file" id="file-input" />
            <img src="" id="preview" :class="attached ? 'preview' : ''" />
            <span class="file-cta" v-if="!attached" style="padding: 10px 5px">
              <span
                class="file-icon"
                style="color: #415da7"
                v-if="doc != 'Photo ID'"
              >
                <i
                  class="fas"
                  :class="
                    doc == 'Photo ID'
                      ? 'fa-id-badge'
                      : doc == 'Voided Check'
                      ? 'fa-money-check'
                      : 'fa-camera'
                  "
                ></i>
              </span>
              <img
                :src="require('@/assets/img/cat_dl.jpg')"
                v-if="doc == 'Photo ID'"
                style="
                  opacity: 0.6;
                  filter: grayscale(50%);
                  margin-bottom: 10px;
                "
              />
              <span class="file-label desktop-only" style="color: #415da7">
                Choose a file…
              </span>
              <span class="file-label mobile-only" style="color: #415da7">
                Take a photo...
              </span>
            </span>
          </label>
        </div>
      </div>
    </div>
    <p style="margin-top: 20px">
      <span class="desktop-only"
        >Accepted formats:
        <strong>PDF, JPG, JPEG, GIF, PNG, BMP</strong>.<br /><br /></span
      >Please do not redact or obscure any part of the documents. This will help
      ensure we can verify your identity as quickly and accurately as possible.
    </p>
    <div class="buttons is-centered" style="margin-top: 30px">
      <a
        class="button is-link padded-button next-button"
        v-if="attached"
        @click="uploadFile"
        :disabled="clicked"
        :class="clicked ? 'is-loading' : ''"
        >Upload</a
      >
    </div>
  </div>
</template>

<script>
import Input from "@/components/shared/Input";
import ApplyPage from "@/components/shared/ApplyPage";
import $ from "jquery";
export default {
  name: "UploadDoc",
  components: {},
  props: {
    doc: String,
    link: String,
    api: String,
  },
  mixins: [ApplyPage],
  data() {
    return {
      file: null,
      attached: false,
      clicked: false,
    };
  },
  methods: {
    previewImage(input) {
      console.log("previewImage");
      var self = this;
      var allowedExtensions = /(\.bmp|\.jpg|\.pdf|\.jpeg|\.png|\.gif)$/i;
      var filePath = input.value;
      if (!allowedExtensions.exec(filePath)) {
        alert(
          "Please upload file with an extension of .jpeg/.jpg/.png/.gif/.pdf/.bmp only."
        );
        input.value = "";
        return false;
      } else {
        if (input.files && input.files[0]) {
          var reader = new FileReader();
          self.attached = false;
          reader.onload = function (e) {
            self.attached = true;
            $("#preview").attr("src", e.target.result);
          };

          reader.readAsDataURL(input.files[0]);
        } else {
          self.attached = false;
        }
      }
    },
    next() {
      this.$emit("next", this.$data);
      console.log(this.$data);
    },
    uploadFile() {
      console.log(this.doc);
      console.log(this.link);
      var self = this;
      if (this.clicked) {
        return;
      }
      if (!$("#file-input").val()) {
        alert("Please upload a valid file.");
        return;
      }
      this.clicked = true;
      var fd = new FormData();
      fd.append("file", $("#file-input")[0].files[0]);
      fd.append("filetype", self.doc);
      fd.append("link", self.link);
      $.ajax({
        type: "POST",
        url: "/api/" + self.api + "/upload-file",
        contentType: false,
        processData: false,
        data: fd,
      })
        .done(function (resp) {
          self.next();
        })
        .fail(function (err) {
          self.clicked = false;
        });
      console.log(fd);
      //upload the file here
    },
  },
  mounted: function () {
    var self = this;
    $("#file-input").on("change", function () {
      self.previewImage(this);
    });
  },
};
</script>

<style scoped>
.file-name {
  text-align: center;
}
.file {
  background-color: transparent;
}
p {
  text-align: center;
}
.column {
  border-radius: 20px;
  border: dotted #00000040;
  margin: 10px 20px;
}
.file-container {
  max-width: 350px;
  border-radius: 20px;
  border: dotted #00000040;
  margin: auto;
  background: #f0f4fa;
}
.file-icon {
  margin-right: 0px;
}
.file.is-link .file-cta {
  background-color: transparent;
}
.file-retry {
  background-color: transparent;
  text-align: center;
}

.preview {
  padding: 20px;
}

@media screen and (min-width: 767px), print {
  .mobile-only {
    display: none;
  }
}

@media screen and (max-width: 768px) {
  .desktop-only {
    display: none;
  }
}
</style>